<template>
  <nav>
    <div v-if="listLiveUsers.find(user => user.entity_id == itemId )">
      <v-avatar
        size="37"
        :style="`color: #`+ intToRGB(hashCode(listLiveUsers.find(user => user.entity_id == itemId ).first_name + listLiveUsers.find(user => user.entity_id == itemId ).last_name))"
        style="border:3px solid;position: fixed;right: 60px;bottom: 52px; z-index:7"
        class="avatar"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <img
              v-if="listLiveUsers.find(user => user.entity_id == itemId ).avatar == null"
              src="../assets/user_images/profile-avatar.png"
              v-on="on"
            >
            <img
              v-else
              :src="listLiveUsers.find(user => user.entity_id == itemId ).avatar"
              v-on="on"
            >
          </template>
          <span>{{ listLiveUsers.find(user => user.entity_id == itemId ).first_name+ ' '+ listLiveUsers.find(user => user.entity_id == itemId ).last_name }} {{ $t('someoneIsEditing') }}</span>
        </v-tooltip>
      </v-avatar>
    </div>
    <v-fab-transition>
      <v-btn
        :to="listLiveUsers.find(user => user.entity_id == itemId ) ? '' : link.route"        
        :color="listLiveUsers.find(user => user.entity_id == itemId ) ? 'grey' : color"
        right
        bottom
        fab
        large
        :class="classes" 
        style="position: fixed; bottom: 20px;right: 10px;z-index:1;" 
        data-testid="edit-button"
        @click.stop="activateDialog"
        class="edit-activity-item-button"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </v-fab-transition>
  </nav>
</template>

<script>
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'

export default {
  mixins: [repeatedMethodsMixin],
  props: {
    link: {
      type: Object,
      default: () => {}
    },
    classes: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'accent'
    }
  },
  data(){
    return{
      itemId:window.location.pathname.split('/')[4],
      activityId: this.$route.params.id,
      liveUsers:[]
    }
  },
  computed:{
    listLiveUsers() {
      return this.$store.state.list
    }
  },
  methods: {
    activateDialog(){
      if(this.listLiveUsers.find(user => user.entity_id == this.itemId)){
        this.$emit('openPreventEditingDialog');
      }
    }
  }
}
</script>